/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Suyog Shrestha",
  logo_name: "Suyog Shrestha",
  nickname: "Senior Software Engineer | AI Builder",
  subTitle:
    "Senior Software Engineer turned AI builder on a mission to become the 100x agentic engineer. Building LLM-powered agents, designing intelligent workflows, and engineering AI tooling that turns a solo developer into a force multiplier.",
  resumeLink:
    "https://drive.google.com/file/d/1abNS2tw-_XxHTX7MZKOflfBL0_SzLEmx/view?usp=sharing",
  portfolio_repository: "https://github.com/suyogster",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/suyogster",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/suyogs/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:suyogshrestha.tech@gmail.com",
    fontAwesomeIcon: "fa-envelope",
    fontAwesomePrefix: "fas",
    backgroundColor: "#D14836",
  },
  {
    name: "Substack",
    link: "https://illuminatemee.substack.com",
    imagePath: "substack-logo.png",
  },
];

const skills = {
  data: [
    {
      title: "AI & Agents",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Building LLM-powered agents and autonomous workflows for intelligent software delivery",
        "⚡ Designing multi-agent orchestration systems with MCP-based integrations",
        "⚡ Engineering RAG pipelines and prompt engineering for production AI tooling",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            backgroundColor: "#000000",
            color: "#3776AB",
          },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building scalable backend systems with Spring Boot, Django, Node.js, and .NET",
        "⚡ Developing responsive frontends and mobile apps with React, React Native, and Angular",
        "⚡ Implementing RESTful APIs and real-time communication systems for production environments",
      ],
      softwareSkills: [
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: {
            color: "#DD0031",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: ".NET",
          fontAwesomeClassname: "simple-icons:dot-net",
          style: {
            color: "#512BD4",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#092E20",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            backgroundColor: "#000000",
            color: "#3776AB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#007396",
          },
        },
      ],
    },
    {
      title: "Blockchain & Web3",
      fileName: "DesignImg",
      skills: [
        "⚡ Developing and deploying interoperable smart contracts across multiple blockchains (Ethereum, Polygon, Base, ICON, Sui)",
        "⚡ Building decentralized applications and marketplaces with Solidity, Web3.js, and Ethers.js",
        "⚡ Architecting on-chain reward distribution and token transfer workflows",
      ],
      softwareSkills: [
        {
          skillName: "Ethereum",
          fontAwesomeClassname: "simple-icons:ethereum",
          style: {
            color: "#3C3C3D",
          },
        },
        {
          skillName: "Solidity",
          fontAwesomeClassname: "simple-icons:solidity",
          style: {
            color: "#363636",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#007396",
          },
        },
      ],
    },
    {
      title: "Cloud & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Deploying and managing applications on AWS and Azure with EC2, S3, Lambda, and Aurora",
        "⚡ Containerizing applications with Docker and orchestrating with Kubernetes",
        "⚡ Setting up CI/CD pipelines and cloud-native deployment workflows",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [
    {
      title: "Georgian College",
      subtitle: "Postgraduate Certificate, Artificial Intelligence",
      logo_path: "georgian_college_logo.svg",
      alt_name: "Georgian College",
      duration: "September 2024 - May 2025",
      descriptions: [
        "⚡ Studied advanced AI concepts including machine learning, deep learning, and natural language processing.",
        "⚡ Built production-ready AI models and learned MLOps best practices.",
        "⚡ Awarded Georgian College Dean's List for academic excellence.",
      ],
      website_link: "https://www.georgiancollege.ca/",
    },
    {
      title: "Georgian College",
      subtitle: "Postgraduate Certificate, Mobile Application Development",
      logo_path: "georgian_college_logo.svg",
      alt_name: "Georgian College",
      duration: "September 2023 - May 2024",
      descriptions: [
        "⚡ Specialized in cross-platform mobile development with React Native and native Android/iOS.",
        "⚡ Built end-to-end mobile applications from design to deployment.",
      ],
      website_link: "https://www.georgiancollege.ca/",
    },
    {
      title: "Deerwalk Institute of Technology",
      subtitle:
        "Bachelor's Degree, Computer Science and Information Technology",
      logo_path: "dwit_logo.png",
      alt_name: "DWIT",
      duration: "2015 - 2019",
      descriptions: [
        "⚡ Studied core computer science subjects including Data Structures, Algorithms, DBMS, OS, Computer Architecture, and AI.",
        "⚡ Completed courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ Worked on the R&D team for development of educational software.",
        "⚡ Presented a research paper about Smart Waste Management in Nepal.",
      ],
      website_link: "https://deerwalk.edu.np/DWIT/",
    },
    {
      title: "Little Angels College",
      subtitle: "Higher Secondary Education, Physical Sciences",
      logo_path: "little_angels_logo.svg",
      alt_name: "Little Angels College",
      duration: "",
      descriptions: [
        "⚡ Completed higher secondary education with a focus on physical sciences and mathematics.",
      ],
      website_link: "#",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "2024 Housing Hackathon",
      subtitle: "- Finalist",
      logo_path: "google_logo.png",
      certificate_link: "#",
      alt_name: "Housing Hackathon",
      color_code: "#4285F499",
    },
    {
      title: "AWS Academy Machine Learning Foundations",
      subtitle: "- AWS Academy Graduate",
      logo_path: "google_logo.png",
      certificate_link: "#",
      alt_name: "AWS",
      color_code: "#FF990099",
    },
    {
      title: "AWS Academy Cloud Foundations",
      subtitle: "- AWS Academy Graduate",
      logo_path: "google_logo.png",
      certificate_link: "#",
      alt_name: "AWS",
      color_code: "#FF990099",
    },
    {
      title: "Data Engineering Foundation",
      subtitle: "",
      logo_path: "google_logo.png",
      certificate_link: "#",
      alt_name: "Data Engineering",
      color_code: "#0C9D5899",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internships",
  description:
    "5+ years of production software across blockchain, web, and mobile. From monoliths to microservices, responsive frontends to cloud-native deployments. Now building the next generation of intelligent software with AI agents and agentic workflows.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Senior Software Engineer",
          company: "Karrier One",
          company_url: "#",
          logo_path: "karrier_one_logo.svg",
          duration: "June 2025 - Present",
          location: "Canada",
          description:
            "Led development of API layers enabling AI-powered workflows with multi-agent orchestration, MCP-based database integrations, and cloud deployment pipelines using .NET and Node.js with PostgreSQL, MySQL, Redis, and AWS Aurora MySQL. Owned revenue-critical business systems including on-chain reward distribution on Sui blockchain, invoicing, and multi-vendor data reconciliation. Built geospatial explorer maps with Google Maps and Mapbox.",
          color: "#0879bf",
        },
        {
          title: "Software Engineer",
          company: "iBriz.ai",
          company_url: "#",
          logo_path: "ibriz_logo.svg",
          duration: "January 2022 - August 2023",
          location: "Remote",
          description:
            "Led development of a decentralized marketplace for smart contract templates using Java and Maven. Deployed interoperable smart contracts across ICON, Base, Polygon, and Ethereum blockchains. Migrated Python-based smart contract codebase to Java for performance optimization. Architected a scalable game server using ExpressJS, MongoDB, and Python with real-time polling.",
          color: "#9b1578",
        },
        {
          title: "Software Engineer",
          company: "Deerhold Ltd.",
          company_url: "http://deerhold.org/",
          logo_path: "deerhold-logo-white.png",
          duration: "September 2020 - January 2022",
          location: "Kathmandu, Nepal",
          description:
            "Led development of US healthcare mobile app using React Native and PubNub for real-time doctor-patient consultations. Built full-stack healthcare web applications with MEAN stack integrating Zoom SDK. Implemented RESTful APIs using Node.js, Python, and Java. Deployed healthcare applications on AWS with EC2, S3, and Lambda.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Developer Intern",
          company: "Deerwalk Compware Ltd.",
          company_url: "http://deerhold.org/",
          logo_path: "deerwalk-logo.png",
          duration: "July 2019 - September 2020",
          location: "Kathmandu, Nepal",
          description:
            "Engineered the frontend of a real-time IoT web application using React and Redux Saga. Developed backend services for a car workshop management system. Designed and deployed a Laravel-based CMS for DWIT News Portal on AWS EC2 with NGINX. Built RESTful APIs and frontend components with React and JavaScript.",
          color: "#ee3c26",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Building AI-powered tools, blockchain applications, and full-stack products. Check out my GitHub for the latest work.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "IMG_2752.jpg",
    description:
      "I'm available on most social media. Feel free to reach out — I can help with AI/ML, full stack development, blockchain, and cloud deployments. Open to collaborating on open source & AI projects.",
    link: "#",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Greater Toronto Area, Canada",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/place/Greater+Toronto+Area,+ON/",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 (437) 233-3788",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
